/**
 * A place for common dateFilter things
 */
namespace appn.dateFilterMini {
    export function init(dfilter: string, customFilterCallBack?: Function) {
        // If no default filter were provided, then default to this month.
        if (!dfilter) {
            const state = getStateOrDefaultAsString();
            dfilter = state ? state : 'ThisMonth';
        }

        setValueFromString(dfilter);
        addEvents(customFilterCallBack);
    }

    function addEvents(customFilterCallBack?: Function) {
        $('.container-date-filter-mini #customFilter').off().on('click', function(e) {
            e.preventDefault();

            const registerItem: any = {
                elementId: 'appnDateFilterMini',
                value: getValueAsString()
            };
            appn.saveMeState.createOrUpdateRegister(registerItem);

            if (customFilterCallBack)
                customFilterCallBack();
        });
    }

    export function updateActiveOptions(value: string): void {
        const appnDateFilterMini = $('.appnDateFilterMini');


        if (!value)
            return;

        const bits = value.split('|');
        if (!bits || !bits[0])
            return;

        appnDateFilterMini.val(bits[0]);
        appn.dataTable.uncheckAllRowsBox();
    }

    /**
     * Will get the date filters value from local storage or direct from UI is not in LS.
     */
    export function getStateOrDefault(): IdtFilterValues {
        const appnDateFilterMini = $('.appnDateFilterMini');
        const dateFilterValue = appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilterMini), getValueAsString()).value;
        const dateFilterValues = getValue(dateFilterValue);
        if (dateFilterValues.type === 'CustomRange')
            $('.container-custom-filter').show();
        else
            $('.container-custom-filter').hide();
        return dateFilterValues;
    }

    export function getStateOrDefaultAsString(): string {
        const appnDateFilterMini = $('.appnDateFilterMini');
        return appn.dataTable.getStateOrDefault(appn.saveMeState.getRegisterId(appnDateFilterMini), getValueAsString()).value;
    }

    export function getValueAsString(): string {
        const activeValue = getValue();
        if (!activeValue)
            return appn.emptyString;

        return activeValue.type + '|' + activeValue.fromDate + '|' + activeValue.toDate;
    }

    export function getValue(valueString?: string): IdtFilterValues {
        // Set the defaults in case of population problems
        const filterValues: IdtFilterValues = {
            type: 'ThisMonth',
            fromDate: appn.emptyString,
            toDate: appn.emptyString
        };

        if (valueString) {
            const bits = valueString.split('|');
            filterValues.type = bits[0];
            filterValues.fromDate = bits[1];
            filterValues.toDate = bits[2];
            return filterValues;
        }

        const appnDateFilterMini = $('.appnDateFilterMini');
        const type = appnDateFilterMini.val();
        if (type)
            filterValues.type = type as string;

        const containerDateFilterMini = $('.container-date-filter-mini');
        filterValues.fromDate = containerDateFilterMini.find('#FromDate').val() as string;
        filterValues.toDate = containerDateFilterMini.find('#ToDate').val() as string;

        return filterValues;
    }

    function isAtLeastOneActive(): boolean {
        if ($('.appnDateFilterMini').val())
            return true;
        return false;
    }

    export function setValueFromString(value: string) {
        if (!value)
            return;

        if (isAtLeastOneActive() && getValueAsString() === value)
            return; // No need to set if already the same

        // Set the active class
        const bits = value.split('|');
        const appnDateFilterMini = $('.appnDateFilterMini');
        appnDateFilterMini.val(bits[0]);

        const containerDateFilterMini = $('.container-date-filter-mini');

        if (bits[1])
            containerDateFilterMini.find('#FromDate').val(bits[1]);

        if (bits[2])
            containerDateFilterMini.find('#ToDate').val(bits[2]);

        appn.dataTable.uncheckAllRowsBox();
    }

    export function reset() {
        setValueFromString('ThisMonth');
    }
}
